import { Setter } from "../../services/ComService"

export enum UserCustomerFktStatus {
  inactive = 0,
  active = 1,
}

export enum UserCustomerFkt {
  generic = 0,
  manager = 1,
}

export interface IUserCustomerFkt {
  id?: number
  userId: number
  customerId: number
  fkt: UserCustomerFkt
  createdAt?: Date
  updatedAt?: Date
  endDate: Date | null
  status?: UserCustomerFktStatus
}

export class UserCustomerFktDTO {
  id: number
  userId: number
  customerId: number
  fkt: UserCustomerFkt
  createdAt: Date
  updatedAt: Date
  endDate: Date | null
  status: UserCustomerFktStatus = UserCustomerFktStatus.active
  
  constructor(data: IUserCustomerFkt) {
    this.id = (data.id !== undefined) ? data.id : -1
    this.userId = data.userId
    this.customerId = data.customerId
    this.fkt = data.fkt
    this.createdAt = data.createdAt || new Date()
    this.updatedAt = data.updatedAt || new Date()
    this.endDate = data.endDate
    this.status = data.status || UserCustomerFktStatus.active
  }

  get() {
    return {
      id: this.id,
      userId: this.userId,
      customerId: this.customerId,
      createdAt: this.createdAt,
      endDate: this.endDate,
      status: this.status
    }
  }

  async save() {
    const data = await Setter(
      'spt/userCustomerFkt',
      this.get(),
      {
        method: this.id === -1 ? 'PUT' : 'PATCH'
      }
    )
    if (data.code === 1) {
      // Everything worked as expected!
      this.id = data.item.id
      return true
    }
    return false
  }

  async delete() {
    await Setter('spt/userCustomerFkt', {
      id: this.id,
    }, {
      method: 'DELETE'
    })
  }
}
